"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.getFiltersData = getFiltersData;
exports.getItineraryFiltersData = getItineraryFiltersData;
exports.getPriceFilterData = getPriceFilterData;
var _map2 = _interopRequireDefault(require("lodash/map"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _concat2 = _interopRequireDefault(require("lodash/concat"));
var _each2 = _interopRequireDefault(require("lodash/each"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _max2 = _interopRequireDefault(require("lodash/max"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _timeFilter = require("./time-filter.utils");
var _filters = require("../../constants/filters.constants");
function getItineraryFiltersData(itinerary) {
  var _ref2;
  return _ref2 = {}, _ref2[_filters.FILTER_MAP.PRICE] = getPriceFilterData(itinerary), _ref2[_filters.FILTER_MAP.STOP] = (0, _max2.default)((0, _map2.default)(itinerary.legs, 'stopCount')), _ref2[_filters.FILTER_MAP.AIRLINE] = itinerary.validatingCarrier, _ref2[_filters.FILTER_MAP.AIRPORT] = (0, _map2.default)(itinerary.legs, function (leg) {
    return {
      origin: leg.originId,
      destination: leg.destinationId
    };
  }), _ref2[_filters.FILTER_MAP.BAGGAGE] = itinerary.hasCheckInBaggage || itinerary.hasFareFamilies || (0, _size2.default)(itinerary.fareFamilies) > 0 ? _filters.BAGGAGE_FILTER_CODE_MAP.HAS_CHECKED_BAGGAGE : _filters.BAGGAGE_FILTER_CODE_MAP.HAS_NOT_CHECKED_BAGGAGE, _ref2[_filters.FILTER_MAP.TIME] = (0, _map2.default)(itinerary.legs, function (_ref) {
    var departureHour = _ref.departureHour,
      arrivalHour = _ref.arrivalHour;
    return {
      origin: (0, _timeFilter.getTimeSegmentByHour)(departureHour),
      destination: (0, _timeFilter.getTimeSegmentByHour)(arrivalHour)
    };
  }), _ref2;
}
function getFiltersData(itineraries) {
  var _itineraries$, _data;
  var filtersDataByItineraries = (0, _map2.default)(itineraries, 'filtersData');
  var legCount = (0, _size2.default)(itineraries === null || itineraries === void 0 ? void 0 : (_itineraries$ = itineraries[0]) === null || _itineraries$ === void 0 ? void 0 : _itineraries$.legs);
  var data = (_data = {}, _data[_filters.FILTER_MAP.AIRLINE] = [], _data[_filters.FILTER_MAP.STOP] = [], _data[_filters.FILTER_MAP.PRICE] = {
    min: Infinity,
    max: 0
  }, _data[_filters.FILTER_MAP.AIRPORT] = [], _data[_filters.FILTER_MAP.BAGGAGE] = [], _data[_filters.FILTER_MAP.TIME] = {
    legCount: legCount
  }, _data);
  (0, _each2.default)(filtersDataByItineraries, function (itineraryFiltersData) {
    data[_filters.FILTER_MAP.PRICE] = {
      min: Math.min(itineraryFiltersData[_filters.FILTER_MAP.PRICE], data[_filters.FILTER_MAP.PRICE].min),
      max: Math.max(itineraryFiltersData[_filters.FILTER_MAP.PRICE], data[_filters.FILTER_MAP.PRICE].max)
    };
    data[_filters.FILTER_MAP.AIRLINE] = (0, _uniq2.default)((0, _concat2.default)(data[_filters.FILTER_MAP.AIRLINE], itineraryFiltersData[_filters.FILTER_MAP.AIRLINE]));
    data[_filters.FILTER_MAP.STOP] = (0, _uniq2.default)((0, _concat2.default)(data[_filters.FILTER_MAP.STOP], itineraryFiltersData[_filters.FILTER_MAP.STOP]));
    data[_filters.FILTER_MAP.BAGGAGE] = (0, _uniq2.default)((0, _concat2.default)(data[_filters.FILTER_MAP.BAGGAGE], itineraryFiltersData[_filters.FILTER_MAP.BAGGAGE]));
    data[_filters.FILTER_MAP.AIRPORT] = (0, _map2.default)(itineraryFiltersData[_filters.FILTER_MAP.AIRPORT], function (_ref3, index) {
      var _data$FILTER_MAP$AIRP, _data$FILTER_MAP$AIRP2;
      var origin = _ref3.origin,
        destination = _ref3.destination;
      return {
        origin: (0, _uniq2.default)((0, _concat2.default)(((_data$FILTER_MAP$AIRP = data[_filters.FILTER_MAP.AIRPORT][index]) === null || _data$FILTER_MAP$AIRP === void 0 ? void 0 : _data$FILTER_MAP$AIRP.origin) || [], origin)),
        destination: (0, _uniq2.default)((0, _concat2.default)(((_data$FILTER_MAP$AIRP2 = data[_filters.FILTER_MAP.AIRPORT][index]) === null || _data$FILTER_MAP$AIRP2 === void 0 ? void 0 : _data$FILTER_MAP$AIRP2.destination) || [], destination))
      };
    });
  });
  return data;
}
function getPriceFilterData(itinerary) {
  if ((0, _get2.default)(itinerary, 'price.roundtripTotal')) {
    return itinerary.price.roundtripTotal;
  }
  if ((0, _get2.default)(itinerary, 'price.cheapestRoundtripTotal')) {
    return itinerary.price.cheapestRoundtripTotal;
  }
  return (0, _get2.default)(itinerary, 'totalPrice');
}